import React, { useState } from "react";

const CustomHeader = (props) => {
  const [showFilter, setShowFilter] = useState(false);

  const onMenuClicked = () => {
    setShowFilter(!showFilter);
    props.showColumnMenu(props.column);
  };

  return (
    <div className="custom-header">
      <div className="custom-header-label">{props.displayName}</div>
      <button className="custom-header-button" onClick={onMenuClicked}>
        <i className="fa fa-filter"></i>
      </button>
    </div>
  );
};

export default CustomHeader;
